import { Layout } from '@jbc-year-end-adj/2024/components/layout/EmployeeLayout';
import { EmployeeInput } from '@jbc-year-end-adj/2024/employeePages/employeeInput';
import { EmployeeFinished } from '@jbc-year-end-adj/2024/employeePages/employeeFinished';
import { EmployeeExpired } from '@jbc-year-end-adj/2024/employeePages/employeeExpired';
import { EmployeeError } from '@jbc-year-end-adj/2024/employeePages/employeeError';
import { EmployeeStart } from '@jbc-year-end-adj/2024/employeePages/employeeStart';

// @ts-ignore;
import { Route, Switch } from 'react-router';

export const Routes = () => {
  return (
    <Layout>
      <Switch>
        <Route path="/employee_input" exact component={EmployeeInput} />
        <Route path="/employee_finished" exact component={EmployeeFinished} />
        <Route path="/employee_expired" exact component={EmployeeExpired} />
        <Route path="/employee_error" exact component={EmployeeError} />
        <Route path="/employee_start" exact component={EmployeeStart} />
      </Switch>
    </Layout>
  );
};
